<template>
  <section class="reservation_progress">
    <div class="placeholder"></div>
    <div class="sticker var_beige" :class="{ is_visible: !showProgressBar }">
      <div class="inner">
        <div class="buttons">
          <!-- <div class="field">
            <input type="checkbox" id="terms-of-service" class="styled" v-model="termsOfService" />
            <label for="terms-of-service">
              <span class="checkbox_presentation">
                <svg width="12" height="12" viewbox="0 0 24 24">
                  <use xlink:href="#tick"></use>
                </svg>
              </span>
              <i18n path="I accept the" class="subtext" tag="div">
                <a href="/terms-and-conditions" target="_blank">{{ $t('Terms and Conditions') }}</a>
              </i18n>
            </label>
          </div> -->

          <app-button @click="nextStep" class="next is_red" ref="nextStep" :isDisabled="!isNextStepIsValid">
            {{ $t('Reserve and go to payment') }}
          </app-button>
        </div>
      </div>
    </div>
    <div class="sticker" :class="{ is_visible: showProgressBar }">
      <div class="inner">
        <div class="basket">
          <svg width="27" :class="{ is_visible: orderStep > 1 }" height="26" viewbox="0 0 27 26">
            <use xlink:href="#cart"></use>
          </svg>
          <div class="basket_info">
            <div class="basket_info_price" :class="{ is_visible: orderStep > 1 && priceFrom }">
              <button
                type="button"
                @click="setOrderStepBySlug('productsSelection')"
                class="basket_info_items"
                :class="{ is_visible: orderStep > 2 }"
              >
                <span>{{ $tc('article', amountOfArticles, { amount: amountOfArticles }) }}</span
                >&nbsp;
                <span class="shadow"></span>
              </button>
              <transition name="slide-fade" mode="out-in">
                <span :key="priceFinal" :class="{ is_visible: !priceFinal }"
                  >{{ priceFinal ? $t('for') : $t('from') }}&nbsp;</span
                >
              </transition>
              <span>{{ currentCurrency }}&nbsp;</span>
              <transition name="slide-fade" mode="out-in">
                <span :key="`${priceFinal}_${priceFrom}`"
                  >{{ (priceFinal || priceFrom) | currency(this.currentCurrency) }}&nbsp;</span
                >
              </transition>
              <span class="shadow"></span>
            </div>
            <button
              type="button"
              class="basket_info_date"
              :class="{ is_visible: orderStep > 1 }"
              @click="setOrderStepBySlug('userNeeds')"
            >
              {{ startDate | date }} - {{ endDate | date }}
              <span class="shadow"></span>
            </button>
          </div>
        </div>
        <div class="buttons">
          <transition name="opacity">
            <app-button
              v-show="orderStep > 1"
              @click="prevStep"
              class="next is_white var_prev is_empty"
              ref="prevStep"
            ></app-button>
          </transition>
          <app-button @click="nextStep" class="next is_red" ref="nextStep" :isDisabled="!isNextStepIsValid">
            {{ $t('next') }}
          </app-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import gsap from 'gsap'
import date from '../../helpers/date-and-time'
import { mapActions, mapState, mapGetters } from 'vuex'
import AppButton from '../atoms/AppButton.vue'
import { CHF, EUR } from '../../helpers/currency'

export default {
  components: { AppButton },
  computed: {
    ...mapState('cart', ['startDate', 'orderStep', 'items']),
    ...mapGetters('cart', ['endDate', 'currentCurrency', 'priceFrom', 'priceFinal', 'isNextStepIsValid']),
    amountOfArticles() {
      return this.items.reduce((sum, curr) => (sum += curr.quantity), 0)
    },
    // termsOfService: {
    //   set(value) {
    //     this.$store.commit('user/setAcceptTermsOfService', value)
    //   },
    //   get() {
    //     return this.$store.state.user.acceptTermsOfService
    //   },
    // },
    showProgressBar() {
      return this.orderStep < 5
    },
  },
  created() {
    // window.addEventListener('keyup', this.keyPress)
  },
  destroyed() {
    // window.removeEventListener('keyup', this.keyPress)
  },
  mounted() {
    this.nextStepButton = this.$refs.nextStep?.$el
    this.prevStepButton = this.$refs.prevStep?.$el
  },
  methods: {
    ...mapActions('cart', ['nextOrderStep', 'prevOrderStep', 'setOrderStepBySlug']),
    nextStep() {
      if (!this.isNextStepIsValid) {
        this.nextStepErrorUI()
      }
      // this.nextStepUI()
      this.nextOrderStep()
    },
    prevStep() {
      // this.prevStepUI()
      this.prevOrderStep()
    },
    // nextStepUI() {
    //   const shadow = this.$refs.nextStep.$refs.shadow
    //   gsap.fromTo(shadow, { opacity: 1, scale: 0.99, duration: 1 }, { opacity: 0, scale: 1.1 })
    // },
    // prevStepUI() {
    //   // gsap.fromTo(this.prevStepButton, { x: -3 }, { x: 3, duration: 0.04, clearProps: 'x', repeat: 10 })
    // },
    nextStepErrorUI() {
      gsap.fromTo(this.nextStepButton, { x: -3 }, { x: 3, duration: 0.04, clearProps: 'x', repeat: 10 })
      gsap.fromTo(this.nextStepButton, { y: -2 }, { y: 2, duration: 0.08, clearProps: 'y', repeat: 5 })
    },
    keyPress(e) {
      if (this.orderStep < 5) {
        if (e.code === 'ArrowRight') this.nextStep()
        if (e.code === 'ArrowLeft') this.prevStep()
      }
    },
  },

  filters: {
    date(value) {
      if (!value) return ''
      return date.format(value, 'ddd DD MMM')
    },
    currency(value, currency) {
      if (!value) return ''

      if (currency === 'EUR') {
        return EUR(value)
      }

      return CHF(value)
    },
  },
}
</script>

<style lang="scss" scoped>
.opacity {
  &-enter-active,
  &-leave-active {
    transition: opacity 0.3s ease;
  }

  &-enter,
  &-leave-to {
    opacity: 0;
  }
}

.slide-fade {
  &-enter-active {
    transition: all 0.2s ease;
  }

  &-leave-active {
    transition: all 0.2s ease;
  }

  &-enter {
    transform: translateY(-10px);
    opacity: 0;
  }

  &-leave-to {
    transform: translateY(10px);
    opacity: 0;
  }
}

.shadow {
  display: block;
  width: 200%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0), #fff 50%);
  transform: translateX(-50%);
  transition: transform 0.3s ease-in;
}

.placeholder {
  display: block;
  min-height: 78px;
}

.sticker {
  $transitionTime: 0.3s;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: $colorWhite;
  z-index: 11;
  transform: translateY(101%);
  opacity: 0;
  visibility: hidden;
  transition: transform $transitionTime, opacity 0s ease $transitionTime, visibility 0s ease $transitionTime;
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);

  &.var_beige {
    transform: translateY(0);
    background: $colorBeige;

    .inner {
      border-top: 2px solid $colorBlack;
    }

    &.is_visible {
      transition: none;
    }
  }

  &.is_visible {
    transition: transform $transitionTime, opacity 0s ease 0s, visibility 0s ease 0s;
    transform: translateY(0);
    opacity: 1;
    visibility: visible;
  }

  .inner {
    @include container;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 18px;
    padding-bottom: 18px;
  }

  .buttons {
    margin-left: auto;
    display: flex;
    align-items: center;

    button {
      margin-left: 20px;
    }

    @include mq($to: tablet) {
      &::v-deep button {
        &:not(:disabled):hover {
          span.label {
            transform: scale(1.1);
          }
        }

        svg.prev,
        svg.next {
          display: none;

          @include mq($from: tablet) {
            display: inline-block;
          }
        }
      }
    }
  }
}

.basket {
  display: flex;
  align-items: center;

  @include mq($from: desktop) {
    transform: translateX(-47px);
  }

  svg {
    opacity: 0;
    transform: translateX(-10px);
    transition: opacity 0.3s, transform 0.3s;
    display: none;

    @include mq($from: tablet) {
      display: inline-block;
    }

    &.is_visible {
      opacity: 1;
      transform: translateX(0);
    }
  }

  &_info {
    @include mq($from: tablet) {
      margin-left: 20px;
    }

    &_price {
      @include fontStyleNavi;
      font-size: 16px;
      overflow: hidden;
      position: relative;

      > .shadow {
        transition: transform 0.1s ease-in 0s;
      }

      &.is_visible {
        > .shadow {
          transform: translate(50%);
          transition: transform 0.5s ease-in 0.2s;
        }
      }

      span {
        display: inline-block;
      }
    }

    &_items {
      @include fontStyleNavi;
      font-size: 16px;
      position: relative;
      cursor: pointer;

      border: none;
      outline: none;
      background: none;

      white-space: nowrap;
      overflow: hidden;
      max-width: 0;
      transition: max-width 0.3s ease-out 0.1s;
      visibility: hidden;

      span {
        text-decoration: underline;
      }

      &.is_visible {
        visibility: visible;
        max-width: 100px;
        transition: max-width 0.3s ease-out;

        .shadow {
          transform: translateX(50%);
          transition: transform 0.3s ease-in 0.05s;
        }
      }

      &:focus,
      &:hover {
        span {
          text-decoration: none;
        }
      }
    }

    &_date {
      @include fontStyleNavi;
      font-size: 12px;
      line-height: calc(15 / 12);
      margin-top: 3px;
      border: 0;
      background: 0;
      outline: none;
      transform: translateY(-15px);
      transition: transform 0.3s;
      text-decoration: underline;
      position: relative;
      overflow: hidden;
      cursor: pointer;
      text-align: left;
      visibility: hidden;

      &:focus,
      &:hover {
        text-decoration: none;
      }

      &.is_visible {
        visibility: visible;
        .shadow {
          transform: translate(50%);
          transition: transform 0.5s ease-in 0.2s;
        }

        .is_visible ~ & {
          transform: translateY(0px);
        }
      }
    }
  }
}

.subtext {
  display: inline-block;
  margin-left: 10px;
}

button.var_prev {
  display: none;

  @include mq($from: tablet) {
    display: inline-block;
  }
}
</style>
